<style lang="less" scoped>
  .legalPersonTwo {
    width: 100%;
    min-height: 100%;
    background-color: #f0f2f6;
    .roof {
      width: 100%;
      height: 100px;
      line-height: 100px;
      text-align: left;
      padding-left: 20px;
      box-sizing: border-box;
      background-color: #21aaff;
      font-size: 30px;
      color: #fff;
      display: flex;
      align-items: center;
      svg {
        margin-right: 20px;
      }
    }
    .header {
      width: 100%;
      background: url('data:image/png;base64,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');
      background-size: 100% 100%;
      .tabs {
        width: 692px;
        height: 153px;
        margin: 0 auto;
        background:rgba(255,255,255,1);
        border-radius:20px;
        display: flex;
        .item {
          flex: 1;
          text-align: center;
          font-size:26px;
          font-family:Microsoft YaHei;
          font-weight:400;
          color: #333333;
          padding-top: 35px;
          box-sizing: border-box;
          position: relative;
          img {
            width: 52px;
            height: 52px;
          }
          .jiantou {
            width: 15px;
            height: 26px;
            position: absolute;
            right: 0;
            bottom: 30px;
          }
        }
        .item:nth-child(2) {
          color:#21AAFF;
        }
      }
    }
    .tabTwo {
      width: 750px;
      height: 662px;
      margin-top: 30px;
      padding: 30px;
      box-sizing: border-box;
      background-color: #fff;
      .item {
        width: 100%;
        height: 110px;
        line-height: 110px;
        border-bottom: 1px solid #D0D6D9;
        font-size:28px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(51,51,51,1);
        span {
          margin-right: 20px;
        }
        input {
          vertical-align: middle;
          display: inline-block;
          width: 70%;
          margin-bottom: 5px;
        }
      }
      .name {
        margin-top: 30px;
        width: 100%;
        height: 48px;
        font-size:26px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height: 48px;
        text-align: left;
      }
      .text {
        width: 100%;
        padding: 20px;
        line-height: 48px;
        box-sizing: border-box;
        font-size:24px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(153,153,153,1);
        text-align: left;
      }
    }
    .nextStep {
      width:682px;
      height:94px;
      line-height: 94px;
      margin: 0 auto;
      margin-top: 55px;
      text-align: center;
      background:rgba(33,170,255,1);
      border-radius:20px;
      font-size:36px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    
  }
</style>

<template>
  <div class="legalPersonTwo">
    <div class="roof">
      <svg t="1591005918644" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1100" width="20" height="20"><path d="M511.609097 961.619254" p-id="1101" fill="#ffffff"></path><path d="M360.749204 511.010463 360.749204 511.010463l382.080022-382.074905c14.762215-14.788821 14.762215-38.777165 0-53.585429-14.812357-14.788821-38.799678-14.788821-53.607942 0L283.415908 481.201553c-1.107217 0.867764-2.190899 1.824555-3.206018 2.843768-14.788821 14.808264-14.788821 38.795585 0 53.585429l408.226518 408.230612c14.808264 14.807241 38.795585 14.807241 53.584406 0 14.785751-14.767332 14.785751-38.754652 0-53.562916L360.749204 511.010463 360.749204 511.010463zM360.749204 511.010463" p-id="1102" fill="#ffffff"></path></svg>公司信息填写
    </div>
    <div class="header">
      <div class="tabs">
        <div class="item" v-for="(o,i) in tabsArr" :key="i">
          <img :src="o.icon" alt="">
          <div>{{o.name}}</div>
          <img v-if="i == 0" class="jiantou" src="/static/images/fanhui-251.png" alt="">
          <img v-if="i == 1" class="jiantou" src="/static/images/fanhui-25.png" alt="">
        </div>
      </div>
    </div>
    <div class="tabTwo">
      <div class="item">
        <!-- <span>公司名称1</span>
        <input type="text" placeholder="请输入公司名称" v-model="companyName1"> -->
        <nut-textinput 
            v-model="companyName1"
            label="公司名称1"
            placeholder="请输入公司名称"
            :has-border="false"
            :clearBtn="true"
            :disabled="false"
        />
      </div>
      <div class="item">
        <!-- <span>公司名称2</span>
        <input type="text" placeholder="请输入公司名称" v-model="companyName2"> -->
        <nut-textinput 
            v-model="companyName2"
            label="公司名称2"
            placeholder="请输入公司名称"
            :has-border="false"
            :clearBtn="true"
            :disabled="false"
        />
      </div>
      <div class="item">
        <!-- <span>公司名称3</span>
        <input type="text" placeholder="请输入公司名称" v-model="companyName3"> -->
        <nut-textinput 
            v-model="companyName3"
            label="公司名称3"
            placeholder="请输入公司名称"
            :has-border="false"
            :clearBtn="true"
            :disabled="false"
        />
      </div>
      <div class="name">*填写须知</div>
      <!-- 系统默认给每个用户分配一个公司名称，通过率较高，不可修改。 -->
      <div class="text">用户可根据自己意愿设置一到三个公司名称，但最终确定的公司名称以实际业务开展过程中用户和平台最终确定。</div>
    </div>
    <div class="nextStep" @click="nextStep">下一步</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      shootingArr:[
        {icon:'/static/images/sicon1.png',name:'标准拍摄'},{icon:'/static/images/sicon2.png',name:'边框缺失'},
        {icon:'/static/images/sicon1.png',name:'照片模糊'},{icon:'/static/images/sicon4.png',name:'闪光强烈'},
      ],
      tabsArr:[
        {icon:'/static/images/icon-test-51.png',name:'个人信息'},
        // {icon:'/static/images/gongsi.png',name:'公司信息'},
        {icon:'/static/images/yinxingqia-31.png',name:'银行卡'}
      ],
      companyName1: null,
      companyName2: null,
      companyName3: null
    }
  },
  computed: {
    
  },
  mounted () { 
    console.log(sessionStorage.getItem('orderItem'))
    var orderItem = sessionStorage.getItem('orderItem')
    if (orderItem) {
      this.companyName1 = orderItem.companyNamesArr[0]
      this.companyName2 = orderItem.companyNamesArr[1]
      this.companyName3 = orderItem.companyNamesArr[2] || ''
    }else {
      this.companyName2 = null
      this.companyName3 = null
      var that = this
      let legalPerson = sessionStorage.getItem('legalPerson')
      // wx.getStorage({
      //   key: 'enroll',
      //   success (res) {
      //     const obj = res.data.regname.split('#') 
      //     console.log(res.data.regname)
      //     console.log(obj)
      //     that.companyName1 = obj[0] + legalPerson.methodName + obj[2]
      //   }
      // })
    }
    
  },
  methods: {
    nextStep() {
      

      if (this.companyName1 || this.companyName2 || this.companyName3) {
        const url = '/legalPersonThree';
        var company_names = [this.companyName1];
        if(this.companyName2) {
          company_names.push(this.companyName2);
        }
        if(this.companyName3) {
          company_names.push(this.companyName3);
        }
        sessionStorage.setItem("companyName", company_names.join('#com#'))
        this.$router.push({ path: url });
      }else {

        this.$toast.warn('请至少填写一个公司名称');
      }
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/legalPersonTwo/index.vue